import queryString from 'query-string';
import { get, post, del } from './apiUtils';

const defaultUrl = '/ProductCategoryTR/';

export default {
  getProductCategoryTRList: query => (query ? get(`${defaultUrl}?${queryString.stringify(query)}`) : get(defaultUrl)),
  saveProductCategoryTR: data => post(defaultUrl, data),
};
